import { r as q, c as h, w as R, a as w } from "./keys-CQjWNUL0.mjs";
var d = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(d);
var S = d.exports, s, f;
function T() {
  return f || (f = 1, s = function() {
  }), s;
}
var i, l;
function b() {
  if (l) return i;
  l = 1;
  var e = q(), t = h, r = R, n = r("match");
  return i = function(o) {
    var a;
    return e(o) && ((a = o[n]) !== void 0 ? !!a : t(o) === "RegExp");
  }, i;
}
var u, v;
function m() {
  if (v) return u;
  v = 1;
  var e = b(), t = TypeError;
  return u = function(r) {
    if (e(r))
      throw new t("The method doesn't accept regular expressions");
    return r;
  }, u;
}
var c, g;
function A() {
  if (g) return c;
  g = 1;
  var e = w, t = String;
  return c = function(r) {
    if (e(r) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return t(r);
  }, c;
}
var p, x;
function I() {
  if (x) return p;
  x = 1;
  var e = R, t = e("match");
  return p = function(r) {
    var n = /./;
    try {
      "/./"[r](n);
    } catch {
      try {
        return n[t] = !1, "/./"[r](n);
      } catch {
      }
    }
    return !1;
  }, p;
}
export {
  m as a,
  A as b,
  I as c,
  b as d,
  S as i,
  T as r
};
//# sourceMappingURL=correct-is-regexp-logic-DUuS52mu.mjs.map
